import { StyleSheet, Font } from "@react-pdf/renderer";
import CopperplateGothicBold from "../../../../../../assets/fonts/copperplate-gothic-bold/CopperplateGothicBold.ttf";
import CopperplateGothicRegular from "../../../../../../assets/fonts/copperplate-gothic-bold/CopperplateGothicLight.ttf";
import OpenSansBold from "../../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import RobotoBold from "../../../../../../assets/fonts/Roboto/Roboto-Bold.ttf";
import RobotoRegular from "../../../../../../assets/fonts/Roboto/Roboto-Regular.ttf";
import RobotoSemiBold from "../../../../../../assets/fonts/Roboto/Roboto-SemiBold.ttf";
import RobotoItalic from "../../../../../../assets/fonts/Roboto/Roboto-Italic.ttf";
import RalewayRegular from "../../../../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import RalewayBold from "../../../../../../assets/fonts/Raleway/Raleway-Bold.ttf";
import Theme from "../../../../../../assets/themes/theme";
Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});
Font.register({
  family: "Copperplate Gothic",
  fonts: [
    { src: CopperplateGothicBold, fontWeight: "bold" },
    { src: CopperplateGothicRegular, fontWeight: "normal" },
  ],
});

Font.register({
  family: "Roboto",
  fonts: [
    { src: RobotoBold, fontWeight: "bold" },
    { src: RobotoRegular, fontWeight: "normal" },
    { src: RobotoSemiBold, fontWeight: "500" },
    { src: RobotoItalic, fontStyle: "italic" },
  ],
});

Font.register({
  family: "Raleway",
  fonts: [
    { src: RalewayRegular, fontWeight: "normal" },
    { src: RalewayBold, fontWeight: "bold" }, //  Explicitly defined
  ],
});
const p_xxs = 4;
const p_xs = 8;
const p_sm = 16;
const p_md = 24;
const p_lg = 32;
const p_xl = 40;
const p_xxl = 48;

const g_xxs = 4;
const g_xs = 8;
const g_sm = 16;
const g_md = 24;
const g_lg = 32;
const g_xl = 40;
const g_xxl = 48;

const ContractStyles = () =>
  StyleSheet.create({
    page: {
      position: "relative",
      paddingVertical: p_lg,
      paddingHorizontal: p_xxl,
    },
    serif_h1: {
      fontFamily: "Copperplate Gothic",
      fontSize: 36,
      // lineHeight: Math.ceil(40/36),
      fontWeight: "bold",
    },
    serif_h2: {
      fontFamily: "Copperplate Gothic",
      fontSize: 24,
      // lineHeight: Math.ceil(28/24),
      fontWeight: "bold",
    },

    serif_h3: {
      fontFamily: "Copperplate Gothic",
      fontSize: 24,
      // lineHeight: Math.ceil(28/24),
      fontWeight: "normal",
    },
    serif_h4: {
      fontFamily: "Copperplate Gothic",
      fontSize: 14,
      // lineHeight: Math.ceil(18/14),
      fontWeight: "bold",
    },
    h3: {
      fontFamily: "Raleway",
      fontSize: 24,
      // lineHeight: Math.ceil(32/24),
      fontWeight: "600",
    },
    contentSemibold: {
      fontFamily: "Open Sans",
      fontSize: 16,
      // lineHeight: Math.ceil(24/16),
      fontWeight: "600",
    },
    contentSmall: {
      fontFamily: "Open Sans",
      fontSize: 14,
      // lineHeight: Math.ceil(20/14),
      fontWeight: "normal",
    },
    labelSmallSemibold: {
      fontFamily: "Open Sans",
      fontSize: 12,
      // lineHeight: Math.ceil(16/12),
      fontWeight: "600",
    },
    buttonTextSmall: {
      fontFamily: "Open Sans",
      fontSize: 12,
      // lineHeight: Math.ceil(16/12),
      fontWeight: "normal",
    },
    labelSmallItalic: {
      fontFamily: "Open Sans",
      fontSize: 12,
      // lineHeight: Math.ceil(16/12),
      fontStyle: "italic",
    },

    px_xxs: {
      paddingHorizontal: p_xxs,
    },
    px_xs: {
      paddingHorizontal: p_xs,
    },
    px_sm: {
      paddingHorizontal: p_sm,
    },
    px_md: {
      paddingHorizontal: p_md,
    },
    px_lg: {
      paddingHorizontal: p_lg,
    },
    px_xl: {
      paddingHorizontal: p_xl,
    },
    px_xxl: {
      paddingHorizontal: p_xxl,
    },
    py_xxs: {
      paddingVertical: p_xxs,
    },
    py_xs: {
      paddingVertical: p_xs,
    },
    py_sm: {
      paddingVertical: p_sm,
    },
    py_md: {
      paddingVertical: p_md,
    },
    py_lg: {
      paddingVertical: p_lg,
    },
    py_xl: {
      paddingVertical: p_xl,
    },
    py_xxl: {
      paddingVertical: p_xxl,
    },
    gap_xxs: {
      gap: g_xxs,
    },
    gap_xs: {
      gap: g_xs,
    },
    gap_sm: {
      gap: g_sm,
    },
    gap_md: {
      gap: g_md,
    },
    gap_lg: {
      gap: g_lg,
    },
    gap_xl: {
      gap: g_xl,
    },
    gap_xxl: {
      gap: g_xxl,
    },
    flex: {
      display: "flex",
    },
    grow: {
      flex: 1,
    },
    flexColumn: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "auto",
    },
    flexRow: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
    spaceBetween: {
      justifyContent: "space-between",
    },
    spaceAround: {
      justifyContent: "space-around",
    },
    spaceEvenly: {
      justifyContent: "space-evenly",
    },
    fitcontent: {
      flex: 0,
    },
    center: {
      justifyContent: "center",
    },
    alignStart: {
      alignItems: "flex-start",
    },
    alignCenter: {
      alignItems: "center",
    },
    alignEnd: {
      alignItems: "flex-end",
    },
    alignStretch: {
      alignItems: "stretch",
    },
    textCenter: {
      textAlign: "center",
    },
    textRight: {
      textAlign: "right",
    },
    headerlogo: {
      top: p_lg,
      left: p_xxl,
      position: "absolute",
      height: 35,
      width: 184,
    },
    footerGraphic: {
      bottom: 0,
      right: 0,
      position: "absolute",
      height: 154,
      width: 171,
    },

    bg_primary: {
      backgroundColor: Theme.colors.Brand1PenBlue,
    },
    bg_white: {
      backgroundColor: Theme.colors.White,
    },
    bg_black: {
      backgroundColor: Theme.colors.Black,
    },
    text_primary: {
      color: Theme.colors.Brand1PenBlue,
    },
    text_white: {
      color: Theme.colors.White,
    },
    text_black: {
      color: Theme.colors.Black,
    },
    text_red: {
      color: "#FF0000",
    },
    text_error: {
      color: Theme.colors.error,
    },
    text_gray_70: {
      color: Theme.colors.Grey70,
    },
    uppercase: {
      textTransform: "uppercase",
    },
    text_wrap: {
      flexWrap: "wrap",
    },
    height_100: {
      height: "100%",
    },
    width_100: {
      width: "100%",
    },
    dottedErrorFillInTheBlank: {
      borderStyle: "dotted",
      borderWidth: 1,
      borderColor: Theme.colors.error,
    },
  });

export default ContractStyles;
